import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import notificationReducer from '../features/notification/notificationSlice';
import dropdownReducer from '../features/dropdowns/dropdownSlice';
import masterReducer from '../features/master/masterSlice';

export const store = configureStore({
	reducer: {
		auth: authReducer,
		notifications: notificationReducer,
		dropdown: dropdownReducer,
		master: masterReducer,
	},
});
